import { render, staticRenderFns } from "./ConsumptionInfoModal.vue?vue&type=template&id=0da12e8c&"
import script from "./ConsumptionInfoModal.vue?vue&type=script&lang=js&"
export * from "./ConsumptionInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports